import script from "./LeaderProjectManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectManagement.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectManagement.vue?vue&type=style&index=0&id=1fa77c60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa77c60"]])

export default __exports__